import React from "react";
import { Check, Gift, ArrowUpRight } from "lucide-react";
import { PHASE2, BONUS } from "../mock";
import { useReveal } from "../hooks/useReveal";

function BonusCard({ b, i }) {
  const ref = useReveal();
  return (
    <div ref={ref} className={`reveal reveal-delay-${i + 1} glass card-lift rounded-2xl overflow-hidden`}>
      <div className="relative h-44 overflow-hidden">
        <img src={b.image} alt={b.title} className="w-full h-full object-cover" loading="lazy" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#070d1c] to-transparent" />
        <span className="absolute top-3 right-3 text-[11px] font-semibold px-3 py-1 rounded-full bg-[#f6e3a8] text-[#10192c]">
          Valeur : {b.value}
        </span>
      </div>
      <div className="p-6">
        <div className="flex items-center gap-2 text-[#7fd8e8] text-xs uppercase tracking-widest mb-2">
          <Gift className="w-3.5 h-3.5" /> Bonus #{b.n}
        </div>
        <h4 className="text-xl text-white leading-snug">{b.title}</h4>
        <p className="mt-3 text-sm text-white/65 leading-relaxed">{b.text}</p>
      </div>
    </div>
  );
}

export default function Phase2({
  bonus = BONUS,
  bonusEyebrow = "Et ce n'est pas tout...",
  bonusTitle = "3 bonus exclusifs",
  bonusHighlight = "d'une valeur totale de 560€",
  bonusCols = "md:grid-cols-3",
}) {
  const head = useReveal();
  const img = useReveal();
  const bonusHead = useReveal();
  return (
    <section className="relative py-24 md:py-28 ocean-bg">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div ref={head} className="reveal text-center max-w-3xl mx-auto">
          <p className="eyebrow text-[#7fd8e8] text-xs mb-4">Phase 2 · Devenir praticien</p>
          <h2 className="text-4xl md:text-5xl text-white leading-tight">
            Canaliser les fréquences vibratoires <span className="text-gold">pour faire des soins énergétiques</span>
          </h2>
        </div>

        <div className="mt-14 grid lg:grid-cols-2 gap-10 items-center">
          <div ref={img} className="reveal relative flex justify-center">
            <div className="absolute inset-0 m-auto w-3/4 h-3/4 rounded-full bg-[#1f6f8b]/30 blur-3xl glow-pulse" />
            <img
              src={PHASE2.image}
              alt="Soins énergétiques"
              className="relative w-[360px] rounded-3xl ring-1 ring-white/10 float-soft"
              loading="lazy"
            />
          </div>
          <div className="space-y-4">
            {PHASE2.items.map((it, i) => (
              <Phase2Item key={it.title} it={it} i={i} />
            ))}
          </div>
        </div>

        {/* Bonus */}
        <div ref={bonusHead} className="reveal text-center max-w-3xl mx-auto mt-28">
          <p className="eyebrow text-[#7fd8e8] text-xs mb-4">{bonusEyebrow}</p>
          <h2 className="text-4xl md:text-5xl text-white leading-tight">
            {bonusTitle} <span className="text-gold">{bonusHighlight}</span>
          </h2>
        </div>
        <div className={`mt-12 grid ${bonusCols} gap-6 max-w-4xl mx-auto`}>
          {bonus.map((b, i) => (
            <BonusCard key={b.n} b={b} i={i} />
          ))}
        </div>
      </div>
    </section>
  );
}

function Phase2Item({ it, i }) {
  const ref = useReveal();
  return (
    <div ref={ref} className={`reveal reveal-delay-${(i % 4) + 1} glass rounded-2xl p-5 flex items-start gap-4 card-lift`}>
      <span className="mt-0.5 w-9 h-9 rounded-xl bg-gradient-to-br from-[#1f6f8b]/50 to-[#5a5ee0]/30 flex items-center justify-center shrink-0 ring-1 ring-white/10">
        <Check className="w-4 h-4 text-[#7fd8e8]" />
      </span>
      <div>
        <h4 className="text-lg text-white flex items-center gap-1">
          {it.title}
          <ArrowUpRight className="w-4 h-4 text-white/30" />
        </h4>
        <p className="text-sm text-white/60 mt-1">{it.text}</p>
      </div>
    </div>
  );
}
